import { topicsData } from '@/mocks/homeData';

export default function SectionTopics() {
  return (
    <section id="topics" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
            话题广场
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">热门话题</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">最热话题标签，快速找到你感兴趣的瓜</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topicsData.map((item) => (
            <div
              key={item.id}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 ${
                item.hot
                  ? 'bg-primary-100 border-primary-200 hover:bg-primary-200'
                  : 'bg-background-100 border-background-200 hover:border-accent-300 hover:bg-background-50'
              }`}
            >
              <span className={`text-sm font-medium whitespace-nowrap ${item.hot ? 'text-primary-700' : 'text-foreground-700'}`}>
                #{item.name}
              </span>
              <span className={`text-[11px] whitespace-nowrap ${item.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                {item.count}
              </span>
              {item.hot && (
                <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-500 text-background-50 font-medium whitespace-nowrap">
                  HOT
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}